(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-facets-form]');
      if (!this.form) return;

      this.details = this.querySelector('details.facets');
      this.onPopState = () => this.apply(window.location.href, false);

      this.addEventListener('change', (event) => {
        if (event.target.form !== this.form || event.target.matches('[data-price-input]')) return;
        this.apply();
      });

      this.addEventListener('input', (event) => {
        if (!event.target.matches('[data-price-input]')) return;
        clearTimeout(this.priceTimer);
        this.priceTimer = setTimeout(() => this.apply(), 500);
      });

      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.apply();
        if (this.details) this.details.open = false;
      });

      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-facet-link]');
        if (link) {
          event.preventDefault();
          this.apply(link.href);
          return;
        }
        if (this.details && (event.target === this.details || event.target.closest('[data-facets-close]'))) {
          this.details.open = false;
        }
      });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.details?.open) return;
        this.details.open = false;
        this.details.querySelector('summary')?.focus();
      });

      this.details?.addEventListener('toggle', () => {
        if (this.details.open || !this.pendingDocument) return;
        this.swap(this.pendingDocument, '[data-facets-body]');
        this.pendingDocument = null;
      });

      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
    }

    buildUrl() {
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(this.form)) {
        if (value !== '') params.append(key, value);
      }
      const query = params.toString();
      return query ? `${this.form.action}?${query}` : this.form.action;
    }

    async apply(url = this.buildUrl(), updateHistory = true) {
      const requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('section_id', this.dataset.sectionId);
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(requestUrl);
        if (!response.ok) throw new Error(response.statusText);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

        [
          '[data-facets-results]',
          '[data-facets-active]',
          '[data-facets-count]',
          '[data-facets-badge]',
          '[data-facets-apply]',
        ].forEach((selector) => this.swap(doc, selector));

        if (this.details?.open) {
          this.pendingDocument = doc;
        } else {
          this.swap(doc, '[data-facets-body]');
        }

        if (updateHistory) {
          requestUrl.searchParams.delete('section_id');
          window.history.pushState({}, '', requestUrl);
        }
      } catch (error) {
        window.location.href = url;
      } finally {
        this.removeAttribute('aria-busy');
      }
    }

    swap(doc, selector) {
      const fresh = doc.querySelector(selector);
      const current = this.querySelector(selector);
      if (!fresh || !current) return;

      current.innerHTML = fresh.innerHTML;
      current.querySelectorAll('a[href*="section_id="]').forEach((link) => {
        const href = new URL(link.href);
        href.searchParams.delete('section_id');
        link.href = href.toString();
      });
    }
  }

  if (!customElements.get('facet-filters')) {
    customElements.define('facet-filters', FacetFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["predictive-search"] && !Shopify.designMode) return;
  try {
    class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-predictive-status]');
      if (!this.input || !this.results) return;

      this.cache = new Map();

      this.input.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.search(this.input.value.trim()), 200);
      });

      this.addEventListener('keydown', (event) => this.onKeydown(event));

      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.close();
      });
    }

    onKeydown(event) {
      if (event.key === 'Escape' && !this.results.hidden) {
        event.stopPropagation();
        this.close();
        this.input.focus();
        return;
      }

      const links = Array.from(this.results.querySelectorAll('a'));
      const index = links.indexOf(document.activeElement);

      if (event.key === 'ArrowDown') {
        const next = index === -1 ? links[0] : links[index + 1];
        if (next) {
          event.preventDefault();
          next.focus();
        }
      } else if (event.key === 'ArrowUp' && index !== -1) {
        event.preventDefault();
        (links[index - 1] ?? this.input).focus();
      }
    }

    async search(terms) {
      if (!terms) {
        this.close();
        return;
      }

      if (this.cache.has(terms)) {
        this.render(this.cache.get(terms));
        return;
      }

      this.controller?.abort();
      this.controller = new AbortController();

      const params = new URLSearchParams({
        q: terms,
        'resources[type]': 'product,collection,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        section_id: 'predictive-search',
      });

      try {
        const response = await fetch(`${this.dataset.url}?${params}`, { signal: this.controller.signal });
        if (!response.ok) throw new Error(response.statusText);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const markup = doc.querySelector('[data-predictive-content]')?.innerHTML ?? '';
        this.cache.set(terms, markup);
        if (this.input.value.trim() === terms) this.render(markup);
      } catch (error) {
        if (error.name !== 'AbortError') this.close();
      }
    }

    render(markup) {
      this.results.innerHTML = markup;
      this.results.hidden = !markup;
      const summary = this.results.querySelector('[data-predictive-summary]');
      if (this.status) this.status.textContent = summary ? summary.textContent : '';
    }

    close() {
      this.results.innerHTML = '';
      this.results.hidden = true;
      if (this.status) this.status.textContent = '';
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }
  } catch(e) { console.error(e); }
})();

})();
